// Artisan function types that have been retired. They're filtered out of
// every dropdown, tab list, and badge display. Partners that still carry
// these types in Firestore are not affected — the type is just hidden
// from the UI so users stop selecting it for new partners.
export const HIDDEN_COMPANY_TYPES = new Set([
  "enduit",
  "assainissement",
  "photovoltaique",
  "cuisine",
  "livraison",
]);

// Declared in display order. Every consumer (PartnersSection,
// CreateProjectModal, dropdowns, tables, …) must preserve this order.
// Do not re-sort alphabetically.
export const COMPANY_TYPE_OPTIONS = [
  { value: "terrassement", label: "Terrassement" },
  { value: "gros_oeuvre", label: "Gros œuvre" },
  { value: "traitement_termite", label: "Traitement termites" },
  { value: "charpente", label: "Charpente" },
  { value: "couverture", label: "Couverture" },
  { value: "etancheite", label: "Étanchéité" },
  { value: "menuiserie", label: "Menuiserie" },
  { value: "ravalement", label: "Ravalement" },
  { value: "gouttieres", label: "Gouttières" },
  { value: "cloisonnement", label: "Plaquisterie" },
  { value: "isolation", label: "Isolation des combles" },
  { value: "electricite", label: "Électricité" },
  { value: "plomberie", label: "Plomberie" },
  { value: "chauffage", label: "Chauffage" },
  { value: "chape", label: "Chape" },
  { value: "carrelage", label: "Carrelage" },
  { value: "parquet", label: "Parquet" },
  { value: "peinture", label: "Peinture" },
  { value: "escalier", label: "Escalier" },
  { value: "nettoyage", label: "Nettoyage" },
  { value: "bureau_d_etudes", label: "Bureau d'études béton" },
  { value: "bureau_d_etudes_thermique", label: "Bureau d'études thermique" },
  { value: "controle_pmr", label: "Contrôle PMR" },
  { value: "controle_re2020", label: "Contrôle RE2020" },
  { value: "architecte", label: "Architecte" },
  { value: "autre", label: "Autre" },
];

export const COMPANY_TYPE_LABELS: Record<string, string> = Object.fromEntries(
  COMPANY_TYPE_OPTIONS.map((o) => [o.value, o.label]),
);

// Virtual "expansions": some categories include partners tagged under
// other, narrower categories. Used to decide which partners surface in a
// given section/column.
export const COMPANY_TYPE_EXPANSIONS: Record<string, string[]> = {
  chauffage: ["plomberie"],
  terrassement: ["gros_oeuvre"],
};

/** True if `partner` belongs in the section for `sectionType`. */
export function partnerMatchesType(
  partnerTypes: string[] | undefined,
  sectionType: string,
): boolean {
  if (!partnerTypes) return false;
  if (partnerTypes.includes(sectionType)) return true;
  const extra = COMPANY_TYPE_EXPANSIONS[sectionType] || [];
  return extra.some((t) => partnerTypes.includes(t));
}
